<main class="admin-layout">
  <aside class="sidebar">
    <a routerLink="/" class="brand" aria-label="S.R.Organic home">
      <span aria-hidden="true">🍄</span>
      <strong>S.R.ORGANIC</strong>
    </a>

    <nav class="sidebar-nav" aria-label="Admin navigation">
      <a
        *ngFor="let item of menuItems; trackBy: trackByMenu"
        class="sidebar-link"
        [routerLink]="item.path"
        routerLinkActive="active"
        [routerLinkActiveOptions]="{ exact: true }"
      >
        <span class="sidebar-link__icon" aria-hidden="true">{{ item.icon }}</span>
        <span class="sidebar-link__label">{{ item.label }}</span>
      </a>
    </nav>

    <div class="sidebar-footer">
      <div class="admin-profile">
        <div class="avatar" aria-hidden="true">A</div>
        <div>
          <strong>Admin</strong>
          <small>admin@srorganic.com</small>
        </div>
      </div>
    </div>
  </aside>

  <section class="admin-main">
    <header class="admin-topbar">
      <div>
        <strong>Admin Dashboard</strong>
        <span>Product management</span>
      </div>

      <button type="button" class="logout-button" (click)="logout()">Logout</button>
    </header>

    <router-outlet />
  </section>
</main>
